import { render, staticRenderFns } from "./Organigram.vue?vue&type=template&id=35a8b2ac&"
import script from "./Organigram.vue?vue&type=script&lang=js&"
export * from "./Organigram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports